export default {
  name: "ErrorDisplayList",
  props: {
    errorsLists: {
      type: Object,
      default: () => { 
        return {
          readings: [],
          sms: [],
          photos: [],
        }
      },
    },
    showDialog: {
      type: Boolean,
      required: true
    }
  },
  data: function() {
    return {}
  },
  methods: {}
}
